/**
 * Labstep
 *
 * @module components/File/IFrame
 * @desc Component to load file into an iframe
 */

import { FileDownloadContainer } from 'labstep-web/containers/File/Download';
import type React from 'react';
import { Component } from 'react';
import type {
  FileIFrameContainerProps,
  FileIFrameProps,
  FileIFrameState,
} from './types';

export class FileIFrame extends Component<
  FileIFrameProps,
  FileIFrameState
> {
  constructor(props: FileIFrameProps) {
    super(props);
    this.state = { url: null };
  }

  componentDidMount() {
    const { downloadFile, file } = this.props;
    downloadFile({
      id: file.id,
      onSuccess: ({ response }) => {
        this.setState({ url: `${response.signed_url}&inline=1` });
      },
    });
  }

  render() {
    const { url } = this.state;

    if (url) {
      return (
        <iframe
          title="snapgene"
          src={url}
          width="100%"
          height="100%"
          frameBorder="0"
        />
      );
    }

    return null;
  }
}

export const FileIFrameContainer: React.FC<
  FileIFrameContainerProps
> = (props) => (
  <FileDownloadContainer file={props.file}>
    {(containerProps) => (
      <FileIFrame {...props} {...containerProps} />
    )}
  </FileDownloadContainer>
);
